var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mng-container" },
    [
      _c("header", { staticClass: "mng-header" }, [
        _c("h1", { staticClass: "mng-title" }, [_vm._v("诗词管理")]),
        _vm._v(" "),
        _c("span", { staticClass: "mng-sub" }, [
          _vm._v("数据源：shici 主页（proj.shici）"),
        ]),
        _vm._v(" "),
        _vm.me.username
          ? _c("span", { staticClass: "mng-user" }, [
              _vm._v(_vm._s(_vm.me.username) + " · " + _vm._s(_vm.me.role)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mng-actions" },
          [
            _c("router-link", { staticClass: "mng-link", attrs: { to: "/" } }, [
              _vm._v("返回主页"),
            ]),
            _vm._v(" "),
            _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.logout } },
              [_vm._v("退出登录")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { size: "small", type: "primary", icon: "el-icon-plus" },
                on: { click: _vm.openCreate },
              },
              [_vm._v("新增")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mng-filters" },
        [
          _c("el-input", {
            staticClass: "f-id",
            attrs: { size: "small", clearable: "", placeholder: "ID" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.search.apply(null, arguments)
              },
            },
            model: {
              value: _vm.filters.id,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "id", $$v)
              },
              expression: "filters.id",
            },
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "f-w",
              attrs: {
                size: "small",
                clearable: "",
                filterable: "",
                placeholder: "标题(词牌)",
              },
              on: { change: _vm.search, clear: _vm.search },
              model: {
                value: _vm.filters.title,
                callback: function ($$v) {
                  _vm.$set(_vm.filters, "title", $$v)
                },
                expression: "filters.title",
              },
            },
            _vm._l(_vm.titleOptions, function (t) {
              return _c("el-option", { key: t, attrs: { label: t, value: t } })
            }),
            1
          ),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "f-w",
            attrs: { size: "small", clearable: "", placeholder: "副标题" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.search.apply(null, arguments)
              },
            },
            model: {
              value: _vm.filters.subtitle,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "subtitle", $$v)
              },
              expression: "filters.subtitle",
            },
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "f-w",
              attrs: {
                size: "small",
                clearable: "",
                filterable: "",
                placeholder: "作者",
              },
              on: { change: _vm.search, clear: _vm.search },
              model: {
                value: _vm.filters.author,
                callback: function ($$v) {
                  _vm.$set(_vm.filters, "author", $$v)
                },
                expression: "filters.author",
              },
            },
            _vm._l(_vm.authorOptions, function (a) {
              return _c("el-option", { key: a, attrs: { label: a, value: a } })
            }),
            1
          ),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "f-w",
            attrs: { size: "small", clearable: "", placeholder: "内容" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.search.apply(null, arguments)
              },
            },
            model: {
              value: _vm.filters.content,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "content", $$v)
              },
              expression: "filters.content",
            },
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "f-s",
              attrs: { size: "small" },
              on: { change: _vm.search },
              model: {
                value: _vm.filters.order,
                callback: function ($$v) {
                  _vm.$set(_vm.filters, "order", $$v)
                },
                expression: "filters.order",
              },
            },
            [
              _c("el-option", { attrs: { label: "新→旧", value: "desc" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "旧→新", value: "asc" } }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "primary",
                icon: "el-icon-search",
                loading: _vm.loading,
              },
              on: { click: _vm.search },
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.resetFilters } },
            [_vm._v("重置")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.error
        ? _c("el-alert", {
            staticClass: "mng-error",
            attrs: {
              type: "error",
              title: _vm.error,
              "show-icon": "",
              closable: false,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loadingOptions
        ? _c("div", { staticClass: "mng-loading-options" }, [
            _vm._v("筛选选项加载中…"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "mng-table-wrap",
        },
        [
          _c("table", { staticClass: "mng-table" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _vm._l(_vm.items, function (row, idx) {
                  return _c("tr", { key: (row.id || "") + idx }, [
                    _c(
                      "td",
                      {
                        staticClass: "c-title",
                        attrs: { "data-label": "标题" },
                      },
                      [_vm._v(_vm._s(row.title))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c-subtitle",
                        attrs: { "data-label": "副标题" },
                      },
                      [_vm._v(_vm._s(row.subtitle || "—"))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c-author",
                        attrs: { "data-label": "作者" },
                      },
                      [_vm._v(_vm._s(row.author))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c-content",
                        attrs: { "data-label": "内容", title: row.content },
                      },
                      [_vm._v(_vm._s(_vm.excerpt(row.content, 60)))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c-time",
                        attrs: { "data-label": "收录时间" },
                      },
                      [_vm._v(_vm._s(_vm.tsToDate(row.createtime)))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c-time",
                        attrs: { "data-label": "录入时间" },
                      },
                      [_vm._v(_vm._s(_vm.tsToDate(row.recordtime)))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c-op", attrs: { "data-label": "操作" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.openEdit(row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.removeItem(row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ],
                      1
                    ),
                  ])
                }),
                _vm._v(" "),
                !_vm.loading && _vm.items.length === 0
                  ? _c("tr", [
                      _c(
                        "td",
                        { staticClass: "mng-empty", attrs: { colspan: "7" } },
                        [_vm._v("暂无数据")]
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mng-pager" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: _vm.pagerLayout,
              "pager-count": _vm.isMobile ? 5 : 7,
              total: _vm.total,
              "current-page": _vm.page,
              "page-size": _vm.pageSize,
              "page-sizes": [10, 20, 50],
            },
            on: {
              "update:currentPage": function ($event) {
                _vm.page = $event
              },
              "update:current-page": function ($event) {
                _vm.page = $event
              },
              "update:pageSize": function ($event) {
                _vm.pageSize = $event
              },
              "update:page-size": function ($event) {
                _vm.pageSize = $event
              },
              "current-change": _vm.query,
              "size-change": _vm.onSizeChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.form.id ? "编辑诗词" : "新增诗词",
            visible: _vm.dialogVisible,
            width: _vm.dialogWidth,
            "custom-class": "mng-form-dialog",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary",
                        loading: _vm.saving,
                      },
                      on: { click: _vm.save },
                    },
                    [_vm._v("保存")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.form,
                "label-position": _vm.isMobile ? "top" : "right",
                "label-width": "90px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "标题", required: "" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "标题 / 词牌" },
                    model: {
                      value: _vm.form.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "title", $$v)
                      },
                      expression: "form.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "副标题" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "副标题（可空）" },
                    model: {
                      value: _vm.form.subtitle,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "subtitle", $$v)
                      },
                      expression: "form.subtitle",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "作者" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "作者" },
                    model: {
                      value: _vm.form.author,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "author", $$v)
                      },
                      expression: "form.author",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "内容", required: "" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 7,
                      placeholder: "诗文内容，多行请换行",
                    },
                    model: {
                      value: _vm.form.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "content", $$v)
                      },
                      expression: "form.content",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "收录时间" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      "value-format": "timestamp",
                      placeholder: "收录时间",
                    },
                    model: {
                      value: _vm.form.createMs,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "createMs", $$v)
                      },
                      expression: "form.createMs",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "录入时间" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      "value-format": "timestamp",
                      placeholder: "录入时间",
                    },
                    model: {
                      value: _vm.form.recordMs,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "recordMs", $$v)
                      },
                      expression: "form.recordMs",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "c-title" }, [_vm._v("标题")]),
        _vm._v(" "),
        _c("th", { staticClass: "c-subtitle" }, [_vm._v("副标题")]),
        _vm._v(" "),
        _c("th", { staticClass: "c-author" }, [_vm._v("作者")]),
        _vm._v(" "),
        _c("th", { staticClass: "c-content" }, [_vm._v("内容")]),
        _vm._v(" "),
        _c("th", { staticClass: "c-time" }, [_vm._v("收录时间")]),
        _vm._v(" "),
        _c("th", { staticClass: "c-time" }, [_vm._v("录入时间")]),
        _vm._v(" "),
        _c("th", { staticClass: "c-op" }, [_vm._v("操作")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }